import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from '../../../../shared/alert/alert.service';
import { AsistenciaUiPort, OpcionesConfirmacion, TipoAviso } from '../ports/asistencia-ui.port';

@Injectable({ providedIn: 'root' })
export class MedellinJovenUiAdapter extends AsistenciaUiPort {
  private readonly alertService = inject(AlertService);
  private readonly toastr = inject(ToastrService);

  confirmar(op: OpcionesConfirmacion): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const icon =
        op.tipo === 'peligro'
          ? 'error'
          : op.tipo === 'advertencia'
            ? 'warning'
            : 'info';

      const mensajeCompleto = op.detalle
        ? `${op.mensaje}<br><small class="text-slate-500">${op.detalle}</small>`
        : op.mensaje;

      this.alertService.openDialog({
        type: 'confirmation-icon',
        icon,
        title: op.titulo,
        message: mensajeCompleto,
        actions: {
          cancel: { label: op.textoCancelar ?? 'Cancelar' },
          confirm: { label: op.textoConfirmar ?? 'Confirmar' }
        },
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false)
      });
    });
  }

  avisar(mensaje: string, tipo: TipoAviso = 'info', duracionMs = 3500): void {
    const opts = { timeOut: duracionMs, progressBar: true, closeButton: true };
    switch (tipo) {
      case 'exito':
        this.toastr.success(mensaje, 'Asistencia MML', opts);
        break;
      case 'error':
        this.toastr.error(mensaje, 'Asistencia MML', opts);
        break;
      case 'advertencia':
        this.toastr.warning(mensaje, 'Asistencia MML', opts);
        break;
      default:
        this.toastr.info(mensaje, 'Asistencia MML', opts);
        break;
    }
  }

  alertar(
    titulo: string,
    mensaje: string,
    tipo: 'error' | 'exito' | 'info' | 'advertencia' = 'info',
    detalle?: string
  ): void {
    const icon =
      tipo === 'exito'
        ? 'success'
        : tipo === 'advertencia'
          ? 'warning'
          : tipo === 'info'
            ? 'info'
            : 'error';

    const mensajeCompleto = detalle
      ? `${mensaje}<br><small class="text-slate-500">${detalle}</small>`
      : mensaje;

    this.alertService.openDialog({
      type: 'confirmation-icon',
      icon,
      title: titulo,
      message: mensajeCompleto,
      actions: {
        confirm: { label: 'Entendido' }
      },
      onConfirm: () => {}
    });
  }
}
